function UserPassword() {
    "use strict";

    this.__type = 'UserPassword:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.UserId = -1;
    this.CurrentPassword = '';
    this.NewPassword = '';
}
if (typeof exports !== 'undefined') {
    module.exports = UserPassword;
}